module.exports = __webpack_public_path__ + "media/assets/images/cancellation/cancellation-6f241e214e4f96989dc9fb37cc344d65.gif";